import script from "./StudentMarks.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudentMarks.vue?vue&type=script&lang=ts&setup=true"

import "./StudentMarks.vue?vue&type=style&index=0&id=fa0920da&lang=sass"

const __exports__ = script;

export default __exports__